import ReactPlayer from 'react-player/youtube';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Card, CardContent, Grid, TextField, Typography } from '@mui/material';
import { Color } from '../../../assets/color';
import { DeleteSvg, EditSvg } from '../../../assets/svg';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const RegistrationNumbers = () => {
    const [mode, setMode] = useState('');
    const dispatch = useDispatch();
    const { registrationNumberData } = useSelector(state => state?.superadminReducer);

    const [inputFieldDetail, setInputFieldDetail] = useState({ registration_number: '' });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data
    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value })); //* Handle Input Field : Error

    //* Handle Reset 
    const handleReset = () => {
        setInputFieldDetail({ registration_number: '' });
        setMode('');
    };

    //* Handle Edit
    const handleEdit = (data) => {
        setInputFieldDetail({ registration_number: data?.registration_number, id: data?._id });
        setMode('Edit');
    };

    //! Handle Submit : Create | Edit
    const handleSubmit = () => {
        console.log({ ...inputFieldDetail });

        if (mode == 'Edit') {
            const payload = {
                id: inputFieldDetail?.id,
                data: {
                    registration_number: inputFieldDetail?.registration_number?.trim(),
                },
                onComplete: () => handleReset()
            }

            //! Dispatching API
            dispatch(SuperadminActions.updateRegistrationNumber(payload));

        } else {
            const payload = {
                data: {
                    registration_number: inputFieldDetail?.registration_number?.trim(),
                },
                onComplete: () => handleReset()
            }
            console.log('Payload ::', payload);

            //! Dispatching API
            dispatch(SuperadminActions.createRegistrationNumber(payload));
        }
    };

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => registrationNumberData?.indexOf(row) + 1, width: '80px' },
        { name: 'Reg.Number', selector: row => <span style={{ textTransform: 'capitalize' }}>{row?.registration_number}</span> },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div>
                    <div onClick={() => dispatch(SuperadminActions.deleteRegistrationNumber({ id: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getRegistrationNumbers());
    }, []);

    return (
        <>
            <RouteHeader title={`Registration Numbers`} sub_title={`Manage valid registration numbers for partner creation`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title={'Partner Registration Numbers'} sub_title={'Manage valid registration numbers for partner creation'} />
                    <div onClick={() => setMode('Add')} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>{mode ? mode : 'Add'} Reg. Number</div>
                </div>

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    {mode && <>
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <TextField label="Registration Number" variant="outlined" fullWidth
                                name="registration_number"
                                value={inputFieldDetail?.registration_number}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.registration_number ? true : false}
                                helperText={inputFieldError.registration_number}
                                onFocus={() => handleInputFieldDetailError("registration_number", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <div onClick={() => setMode('')} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '14px', cursor: 'pointer' }}>Cancel</div>
                                </Grid>

                                <Grid item>
                                    <div onClick={handleSubmit} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: Color.white, fontSize: '14px', cursor: 'pointer' }}>{mode} Reg. Number</div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </>}

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={registrationNumberData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default RegistrationNumbers;